import { useEffect, useState } from "react";
import { TrendingUp, ShieldCheck } from "lucide-react";
import { api } from "@/lib/api";

const Card = ({ icon: Icon, label, winner, message, detail, testId }) => (
  <div className="relative overflow-hidden rounded-2xl border border-lasso-line bg-white p-6" data-testid={testId}>
    <div className="absolute -right-6 -top-6 h-24 w-24 rounded-full bg-lasso-sky/30" />
    <p className="relative flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-lasso-deep"><Icon className="h-4 w-4" /> {label}</p>
    {winner ? (
      <>
        <p className="relative mt-3 font-display text-xl font-bold" data-testid={`${testId}-name`}>{winner.name}</p>
        <p className="relative mt-1 text-sm text-zinc-600" data-testid={`${testId}-detail`}>{detail(winner)}</p>
      </>
    ) : (
      <p className="relative mt-3 text-sm text-muted-foreground" data-testid={`${testId}-message`}>{message}</p>
    )}
  </div>
);

export const Highlights = () => {
  const [h, setH] = useState(null);
  useEffect(() => { api.get("/reports/highlights").then((r) => setH(r.data)).catch(() => {}); }, []);
  if (!h) return null;
  return (
    <section className="mb-8" data-testid="reports-highlights">
      <h2 className="mb-4 font-display text-sm font-bold uppercase tracking-[0.14em]">This week's shout-outs <span className="ml-2 font-sans text-xs font-normal normal-case tracking-normal text-muted-foreground">{h.scope_label}</span></h2>
      <div className="grid gap-4 md:grid-cols-2">
        <Card icon={TrendingUp} label="Most improved" winner={h.most_improved} message={h.most_improved_message} testId="highlight-most-improved"
          detail={(w) => `Up ${w.delta} pts — ${w.from_pct}% → ${w.pct}% complete over the last 7 days`} />
        <Card icon={ShieldCheck} label="Fewest overdue" winner={h.fewest_overdue} message={h.fewest_overdue_message} testId="highlight-fewest-overdue"
          detail={(w) => `${w.overdue} overdue item${w.overdue === 1 ? "" : "s"} · ${w.pct}% complete`} />
      </div>
    </section>
  );
};
